/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";

// Material Kit 2 React components
// import MKBox from "components/MKBox";
import { Box } from "@mui/material";
import MKTypography from "components/MKTypography";

function CenteredFooter({ company, light }) {
  const { name } = company;

  // const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      // py={[3, 4]}
      style={{
        paddingTop: 12,
        paddingBottom: 12,
        width: "100%",
        // maxHeight: 114,
        // minHeight: 114,
        backgroundColor: "#F0FFF4",
        boxShadow: "0px 2px 2px rgba(66, 66, 66, 0.2), 0px 0px 4px rgba(66, 66, 66, 0.2)",
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={8} sx={{ textAlign: "center" }}>
          <MKTypography
            style={{
              color: light ? "#285E61" : "black",
              fontWeight: 700,
              fontSize: "16px",
              display: "inline-block",
            }}
          >
            {/* Copyright &copy; {year}{" "} */}
            <MKTypography
              component={Link}
              style={{ color: light ? "#285E61" : "black", fontWeight: 700, fontSize: "16px" }}
            >
              {name}
            </MKTypography>
            {/* . */}
          </MKTypography>
        </Grid>
      </Grid>
    </Box>
  );
}

// Setting default values for the props of CenteredFooter
CenteredFooter.defaultProps = {
  // company: { href: "#", name: "PT Telkom Indonesia (Persero) Tbk" },
  company: { href: "#", name: "" },
  light: false,
};

// Typechecking props for the CenteredFooter
CenteredFooter.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  light: PropTypes.bool,
};

export default CenteredFooter;
